<nz-modal nzCentered class="custom-modal" nzClassName="addUpateModal" [nzMaskClosable]="false" [(nzVisible)]="isVisible"
    [nzTitle]="editStockDetail ? 'Edit Stock' : (isImportClicked ? 'Import Stock' : 'Add New Stock')" [nzWidth]="1000"
    [nzOkDisabled]="!isImportClicked && lst_PartNumber.length == 0 || !isStockNameValid" nzOkText="Save"
    nzCancelText="Cancel" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
        <div class="modal-height">
            <form nz-form [formGroup]="_fS.addUpdateStockForm" class="modal">
                <input nz-input style="display: none" />
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control nzErrorTip="Stock name is required"
                                class="input-field input-box required-input-icon">
                                <nz-form-label nzRequired nzFor="Name" class="modal-label">Stock Name</nz-form-label>
                                <input [ngClass]="{'error-input' : !isStockNameValid}" nz-input formControlName="name"
                                    id="Name" class="input" placeholder="Enter Stock Name" (keyup)="validateStockName()"
                                    autocomplete="off" />
                                <span class="text-danger"
                                    *ngIf="!isStockNameValid && !_fS.addUpdateStockForm.controls['name'].hasError('required')">Stock
                                    name is already exist</span>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control nzErrorTip="ETA date is required"
                                class="input-field input-box required-input-icon">
                                <nz-form-label nzRequired nzFor="eat" class="modal-label"><span
                                        nzTooltipTitle="Estimated Stock Arrival Date"
                                        [nzTooltipPlacement]="['topLeft', 'leftTop']" nz-tooltip
                                        [nzTooltipColor]="_cS.tooltipColor"> ETA Date</span>
                                </nz-form-label>
                                <br>
                                <nz-date-picker formControlName="etaDate" id="eat" nzPlaceHolder="Select ETA Date"
                                    [nzInputReadOnly]="true" [nzFormat]="'MM/dd/yyyy'"
                                    (ngModelChange)="onDateChange($event)">
                                </nz-date-picker>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                        *ngIf="!isImportClicked">
                        <nz-form-control nzErrorTip="Status is required"
                            class="input-field input-box required-input-icon">
                            <label _ngcontent-ryv-c74="" for="Name"
                                class="form-label small-label edit-label stock-status-text">Stock
                                Status</label>
                            <br>
                            <nz-radio-group formControlName="status" nzButtonStyle="solid">
                                <label class="radio-group-label" nz-radio-button [nzValue]=+s.id
                                    *ngFor="let s of _cS.lst_StockLocation;">{{s.value}}</label>
                            </nz-radio-group>
                        </nz-form-control>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control class="input-field input-box">
                                <nz-form-label nzFor="containerNumber" class="modal-label">Container Number
                                </nz-form-label>
                                <input nz-input formControlName="containerNumber" id="containerNumber" class="input"
                                    placeholder="Enter Container Number" autocomplete="off" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row top_margin" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                        *ngIf="!isImportClicked">
                        <nz-form-control>
                            <button class="add-new-number-btn" nz-button nzType="default" nz-popover
                                [nzPopoverTitle]=" titleTemplate" nzPopoverTrigger="click"
                                [nzPopoverOverlayClassName]="'stock-popover'" [(nzPopoverVisible)]="isAddPartPopOver"
                                (nzPopoverVisibleChange)="hideShowAddPart($event)"
                                [nzPopoverContent]="addPartNumberTemplate" nzPopoverPlacement="rightTop"><i nz-icon
                                    nzType="plus-circle" nzTheme="outline"></i>
                                Add Part Number </button>
                        </nz-form-control>
                    </div>
                    <div class="gutter-row change_ship_date" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                        *ngIf="isImportClicked">
                        <!-- <button type="button" nz-button nzType="default"
                            class="new-btn right_margin cancel-btn float-right" (click)="downloadFile()"><i nz-icon
                                nzType="arrow-down"></i> Download sample CSV
                            file</button> -->
                        <a class="float-right" nz-button nzSize="large" nzType="link" (click)="downloadFile()">Download
                            sample CSV
                            file</a>
                    </div>
                    <div class="gutter-row top_margin" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                        *ngIf="isImportClicked">

                        <nz-form-control>
                            <input type="file" style="display:none" #fileInput (change)="uploadedCSVInfo($event)"
                                accept=".csv">
                            <nz-upload nzType="drag" [nzMultiple]="false" accept=".csv"
                                [nzCustomRequest]="customRequest" nzListType="picture"
                                (nzChange)="handleChange($event)">
                                <p class="ant-upload-drag-icon">
                                    <i nz-icon nzType="inbox"></i>
                                </p>
                                <p class="ant-upload-text"> Choose CSV file <br>OR <br>Drag and
                                    drop CSV file here</p>
                            </nz-upload>

                        </nz-form-control>
                    </div>
                </div>
            </form>
            <br>
            <nz-table nzTableLayout="fixed" #sortTable #basicTable class="part-number-table"
                [nzScroll]="{ y: 'calc(100vh - 30em)' }" [nzData]="lst_PartNumber" [nzShowPagination]="false"
                [nzPageSize]="lst_PartNumber.length" *ngIf="lst_PartNumber.length > 0">
                <thead>
                    <tr class="tableheader">
                        <th nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortPart(!isAscPart)">Part Number</th>
                        <th [nzAlign]="'right'" nzWidth="50px">Ordered</th>
                        <th [nzAlign]="'left'" nzWidth="170px">Notes</th>
                        <th [nzAlign]="'right'" nzWidth="50px">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let p of basicTable.data; let pi = index;">
                        <td>{{p.partNumber }}</td>
                        <td [nzAlign]="'right'">{{ p.orderedQuantity }}</td>
                        <td [nzAlign]="'left'" class="note-column">{{ p.note ? p.note : '-' }}</td>
                        <td [nzAlign]="'right'">
                            <a nz-popover [nzPopoverTitle]="'Edit Part'" nzPopoverTrigger="click"
                                [(nzPopoverVisible)]="isEditPartPopOver && currentPartId == p.id"
                                [nzPopoverContent]="addPartNumberTemplate"
                                (nzPopoverVisibleChange)="hideShowEditPart($event,p)" nzPopoverPlacement="left">
                                <img *ngIf="_fS.addUpdateStockForm.get('status')?.value == 1"
                                    src="../assets/images/edit.svg" class="mr-1">
                            </a>
                             <a nz-popconfirm nzPopconfirmTitle="Are you sure want to remove part?" nzOkText="ok"
                                nzCancelText="cancel" (nzOnConfirm)="removePartNumber(p,pi)" (nzOnCancel)="cancel()" nzOkText="Yes" nzCancelText="No">
                                <img class="mr-1 close-icon" src="./assets/images/Close.svg">
                            </a>
                        </td>
                    </tr>
                </tbody>
                <!-- <tbody *ngIf="isPartsLoading">
                    <tr *ngFor="let i of [].constructor(5)">
                        <ng-container *ngFor="let i of [].constructor(6)">
                            <td [nzAlign]="'left'" class="loading">
                                <div class="bar"></div>
                            </td>
                        </ng-container>
                    </tr>
                </tbody> -->
            </nz-table>
            <ng-template #titleTemplate>
                Add New Part Number <i class="float-right pointer" (click)="hideShowAddPart(false)"><img
                        class="close-icon" src="./assets/images/Close.svg"></i>
            </ng-template>
            <ng-template #addPartNumberTemplate>
                <form nz-form [formGroup]="_fS.addPartNumberForm" class="modal">
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Part number is required" nzRequired
                            class="input-field input-box required-input-icon">
                            <nz-select *ngIf="!isEditPartPopOver" formControlName="partNumber" nzShowSearch
                                nzPlaceHolder="Select Part Number" (ngModelChange)="onSelectPartNumber($event)">
                                <nz-option [nzValue]="c.value" [nzLabel]="c.text" *ngFor="let c of lst_Parts">
                                </nz-option>
                            </nz-select>
                            <span class="text-danger"
                                *ngIf="isPartNumberExist && !_fS.addPartNumberForm.controls['partNumber'].hasError('required') && !isEditPartPopOver">
                                Part number is already added
                            </span>
                            <input *ngIf="isEditPartPopOver" nz-input class="input disable" readonly
                                formControlName="partNumber" />
                        </nz-form-control>
                        <!-- <nz-form-control nzErrorTip="Part number is required" nzRequired class="input-field input-box required-input-icon">
                            <input class="input" nz-input formControlName="partNumber" placeholder="Enter Part Number" />
                        </nz-form-control> -->
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Ordered quantity is required" nzRequired
                            class="input-field input-box required-input-icon">
                            <input type="number" class="input" nz-input formControlName="orderQuantiry"
                                placeholder="Enter Ordered Quantity" min="1" step="1"
                                (keypress)="_cS.validateNumber($event)" (focusout)="checkQuantity()"
                                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" />
                            <!-- <nz-input-number style="width: 180px;" formControlName="orderQuantiry" placeholder="Enter Ordered Quantity" [nzMin]="1" [nzStep]="1" [nzInputMode]="'numeric'"></nz-input-number> -->
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-control class="input-field input-box required-input-icon">
                            <textarea class="input" formControlName="notes" nz-input rows="2" maxlength="200"
                                placeholder="Enter Notes"></textarea>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="mb-0 text-right">
                        <nz-form-control>
                            <button *ngIf="!isEditPartPopOver" nz-button nzType="default"
                                class="modal-footer-btn cancel-btn right_margin"
                                (click)="hideShowAddPart(false)">Cancel</button>
                            <button *ngIf="isEditPartPopOver" nz-button nzType="default"
                                class="modal-footer-btn cancel-btn right_margin"
                                (click)="hideShowEditPart(false,null) ">Cancel</button>
                            <button class="btn-blue modal-footer-btn" nz-button nzType="primary"
                                (click)="addPartNumber()">Save</button>
                            <!-- 
                                <button class="btn-blue modal-footer-btn" nz-button nzType="primary"
                                (click)="addPartNumber()" [disabled]="isQuantityExists">Save</button> -->
                        </nz-form-control>
                    </nz-form-item>
                </form>
            </ng-template>
        </div>
    </ng-container>
</nz-modal>